<template>
    <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
            <img src="static/img/avatars/0.png" class="img-avatar" alt="account">
        </template>
        <b-dropdown-item @click="naaraccount" style="background-color: #79d7ff;pointer-events: none;"><i class="fa fa-user" style="color: inherit"></i> &nbsp;{{user.voornaam}} {{user.naam}} ({{user.rol}})</b-dropdown-item>
        <!-- <b-dropdown-header tag="div" class="text-center"><strong>Instellingen</strong></b-dropdown-header> -->
        <b-dropdown-item @click="naaraccount"><i class="fa fa-key"></i> Mijn account</b-dropdown-item>
        <!-- <b-dropdown-item><i class="fa fa-wrench"></i> Instellingen</b-dropdown-item> -->
        <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Afmelden</b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
export default {
    name: 'header-dropdown',
    created () {
        if (Object.keys(this.user).length === 0) {
            this.$store.dispatch('getUser');
        }
    },
    computed: {
        user () {
            return this.$store.getters.user;
        },
    },
    methods: {
        logout () {
            this.$store.dispatch('logout');
            this.$router.replace('/pages/login');
        },
        naaraccount () {
            this.$router.replace('/mijnaccount');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/nav_components/HeaderDropdown.vue